import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios, loggingAxios } from "../../../App";

export function fetchCoordinatorReservations({ params }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/coordinators/`,
    {
      params,
    }
  );
}

export function retrieveCoordinatorReservation({ reference }) {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/coordinators/${reference}/`
  );
}

export async function patchCoordinatorReservation({ reference, payload }) {
  return await loggingAxios.patch(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/coordinators/${reference}/`,
    payload
  );
}
export async function getCoordinatorReservationStats({ params }) {
  return await authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/coordinators/stats/`,
    { params }
  );
}
